<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 2C21.7614 2 24 4.23858 24 7V17C24 19.7614 21.7614 22 19 22H5C2.23858 22 0 19.7614 0 17V7C0 4.23858 2.23858 2 5 2H19ZM9.23438 20H19C20.6569 20 22 18.6569 22 17V16.7607L16.5566 11.0137L9.23438 20ZM5 4C3.34315 4 2 5.34315 2 7V17C2 18.6569 3.34315 20 5 20H6.65527L15.0059 9.75C15.768 8.81481 17.1791 8.7628 18.0088 9.63867L22 13.8516V7C22 5.34315 20.6569 4 19 4H5ZM7.5 6C9.433 6 11 7.567 11 9.5C11 11.433 9.433 13 7.5 13C5.567 13 4 11.433 4 9.5C4 7.567 5.567 6 7.5 6ZM7.5 8C6.67157 8 6 8.67157 6 9.5C6 10.3284 6.67157 11 7.5 11C8.32843 11 9 10.3284 9 9.5C9 8.67157 8.32843 8 7.5 8Z"
      fill="currentColor"
    />
  </svg>
</template>
